export type EventHandler = (...args: unknown[]) => void;

export type PlayerEventBus = {
  on: (event: string, handler: EventHandler) => void;
  off: (event: string, handler: EventHandler) => void;
  emit: (event: string, ...payload: unknown[]) => void;
  clear: () => void;
};

export function createEventBus(): PlayerEventBus {
  const listeners = new Map<string, Set<EventHandler>>();

  const on: PlayerEventBus['on'] = (event, handler) => {
    let set = listeners.get(event);
    if (!set) {
      set = new Set();
      listeners.set(event, set);
    }
    set.add(handler);
  };

  const off: PlayerEventBus['off'] = (event, handler) => {
    listeners.get(event)?.delete(handler);
  };

  const emit: PlayerEventBus['emit'] = (event, ...payload) => {
    const set = listeners.get(event);
    if (!set) return;
    set.forEach((h) => {
      try {
        h(...payload);
      } catch {
        /* listener fault isolation */
      }
    });
  };

  const clear: PlayerEventBus['clear'] = () => {
    listeners.clear();
  };

  return { on, off, emit, clear };
}
